// extracted by mini-css-extract-plugin
export default {"switch":"ToggleSlider_switch__jV2WS","slider":"ToggleSlider_slider__sXx0n"};